export const ApprovedStatus = {
  NOT_APPROVED: 'NOT_APPROVED',
  PENDING: 'PENDING',
  SYNCED: 'SYNCED',
};

export const ApprovedStatusLabel = {
  [ApprovedStatus.NOT_APPROVED]: 'Not Approved',
  [ApprovedStatus.PENDING]: 'Pending',
  [ApprovedStatus.SYNCED]: 'Synced',
};

export const MULTIPLE_LABEL = 'Multiple';

export const approvedStatusOptions = [
  {
    value: ApprovedStatus.PENDING,
    label: ApprovedStatusLabel[ApprovedStatus.PENDING],
  },
  {
    value: ApprovedStatus.SYNCED,
    label: ApprovedStatusLabel[ApprovedStatus.SYNCED],
  },
];
